/* My Header — assets/my-header.js */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollBound = false;

  /* ---------- Scroll shadow (rAF throttled, passive) ---------- */
  function bindScroll() {
    if (scrollBound) return;
    scrollBound = true;
    var ticking = false;
    function update() {
      var h = document.querySelector('.my-header');
      if (h) h.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Typing placeholder ---------- */
  function initTyping(header) {
    var els = header.querySelectorAll('.typing-text');
    if (!els.length) return;

    var words = (header.getAttribute('data-typing-words') || 'Beerbani')
      .split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (!words.length) words = ['Beerbani'];

    function render(t) { for (var i = 0; i < els.length; i++) els[i].textContent = t; }

    if (reduceMotion) { render(words[0] + '...'); return; }

    var w = 0, c = 0, deleting = false, timer;

    function tick() {
      if (!header.isConnected) return;
      if (document.hidden) { timer = setTimeout(tick, 600); return; }

      var word = words[w] + '...';
      var delay = 110;

      if (!deleting) {
        c++;
        if (c >= word.length) { deleting = true; delay = 1400; }
      } else {
        c--;
        delay = 55;
        if (c <= 0) { deleting = false; w = (w + 1) % words.length; delay = 300; }
      }
      render(word.substring(0, c));
      timer = setTimeout(tick, delay);
    }

    // Start when idle so it never competes with LCP
    if ('requestIdleCallback' in window) requestIdleCallback(tick, { timeout: 3000 });
    else window.addEventListener('load', tick);

    // Hide fake placeholder while input has text
    header.querySelectorAll('.typing-placeholder').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      function sync() { wrap.classList.toggle('has-value', input.value.trim() !== ''); }
      input.addEventListener('input', sync);
      sync();
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer(header) {
    var drawer = document.getElementById('mobileDrawer');
    var hamburger = header.querySelector('.my-header__hamburger');
    if (!drawer || !hamburger) return;

    var closeBtn = drawer.querySelector('.mobile-drawer__close');
    var overlay = drawer.querySelector('.mobile-drawer__overlay');
    var panel = drawer.querySelector('.mobile-drawer__panel');
    var root = document.documentElement;

    function open() {
      drawer.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      root.classList.add('mh-lock');
      // focus after the transition starts to avoid a jank frame
      setTimeout(function () { if (closeBtn) closeBtn.focus({ preventScroll: true }); }, 50);
    }

    function close() {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      root.classList.remove('mh-lock');
      hamburger.focus({ preventScroll: true });
    }

    hamburger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    // Close on in-drawer link tap so it never stays open on back navigation
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) { drawer.classList.remove('active'); root.classList.remove('mh-lock'); }
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('active')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') { // simple focus trap
        var f = panel.querySelectorAll('a[href], button, summary, input');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Reset if viewport grows to desktop while open
    var mq = window.matchMedia('(min-width: 768px)');
    var onChange = function (e) {
      if (e.matches && drawer.classList.contains('active')) {
        drawer.classList.remove('active');
        root.classList.remove('mh-lock');
      }
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    // Smooth accordion: one section open at a time
    var sections = drawer.querySelectorAll('.drawer-section');
    sections.forEach(function (sec) {
      var head = sec.querySelector('.drawer-section__head');
      if (!head) return;
      head.addEventListener('click', function () {
        var willOpen = !sec.classList.contains('is-open');
        sections.forEach(function (o) {
          o.classList.remove('is-open');
          var h = o.querySelector('.drawer-section__head');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) { sec.classList.add('is-open'); head.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  function init() {
    var header = document.querySelector('.my-header');
    if (!header || header.__mhInit) return;
    header.__mhInit = true;
    bindScroll();
    initTyping(header);
    initDrawer(header);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function () {
    document.documentElement.classList.remove('mh-lock');
    init();
  });
})();